export var ENV_ENUM;
(function (ENV_ENUM) {
  ENV_ENUM["pc"] = "pc";
  ENV_ENUM["android"] = "android";
  ENV_ENUM["ios"] = "ios";
  ENV_ENUM["notInYach"] = "notInYach";
})(ENV_ENUM || (ENV_ENUM = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/sdk/sdk.typings.js
// module id = null
// module chunks = 